import React from 'react';
import Loader from "react-js-loader";

const DataLoader = () => {
  return (
    <Loader type="hourglass" bgColor={"#ed1c24"} title={"Data Loading..."} color={'#ed1c24'} size={100} />
  );
};

export default DataLoader;